import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/CraneHVACC";

export const CRANE_HVACC_PREFIX_URL = PREFIX_URL;

export const GetAll = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetAll`, options);

export const Create = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Create`, options);

export const GetById = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetById/:id`, options);

export const Update = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Update/:id`, options);

export const Delete = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Delete/:id`, options);

export const Calculate = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Calculate`, options);

export const GetCraneParameters = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetCraneParameters`, options);

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  Calculate,
  GetCraneParameters,
};
